/**
 *
 * SaveModal
 *
 */

import React from 'react';
// import PropTypes from 'prop-types';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { compose } from 'redux';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import withUser from 'containers/User/withUser';
import withRoutes from 'containers/Routes/withEntity';
import renderField from 'components/FormField/renderField';
import PrimaryAction from 'components/PrimaryAction';
import prepareRoute from 'utils/prepareRoute';
import messages from './messages';

class SaveModal extends React.PureComponent {
  constructor(props) {
    super(props);
    const {
      route: { meta },
    } = props;
    const defaults = {
      // saving: false,
      title: '',
      description: '',
      isPublic: true,
      replace: true,
      city: '',
      province: '',
      country: '',
    };
    this.state = { ...defaults, ...meta, replace: undefined };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = renderField.bind(this)(messages);
  }

  static getDerivedStateFromProps(props, state) {
    const {
      route: { meta },
    } = props;
    return {
      city: state.city || meta.city || '',
      province: state.province || meta.province || '',
      country: state.country || meta.country || '',
    };
  }

  handleSubmit(ev) {
    ev.preventDefault();
    const { route, apiChange } = this.props;
    const body = prepareRoute({ ...route, meta: this.state });
    if (this.state.replace !== 'replace') {
      delete body.id;
    }
    apiChange({ body });
  }

  render() {
    const { onHide, user, route } = this.props;
    const canReplace = route.meta.user_id === user.api.userId;
    const replaceOptions = ['replace', 'createNew'].map(option => ({
      value: option,
      label: <FormattedMessage {...messages[option]} />,
    }));
    return (
      <Modal show onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage {...messages.header} />
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={this.handleSubmit}>
          <Modal.Body>
            {this.renderField({
              id: 'title',
              type: 'text',
              autoFocus: true,
              required: true,
            })}
            {this.renderField({
              id: 'description',
              componentClass: 'textarea',
            })}
            {this.renderField({ id: 'city', type: 'text', required: true })}
            {this.renderField({ id: 'province', type: 'text' })}
            {this.renderField({ id: 'country', type: 'text', required: true })}
            {this.renderField({ id: 'isPublic', componentClass: 'checkbox' })}
            {canReplace &&
              this.renderField({
                id: 'replace',
                componentClass: 'radio',
                options: replaceOptions,
                required: true,
              })}
          </Modal.Body>
          <Modal.Footer>
            <PrimaryAction />
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

SaveModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  apiChange: PropTypes.func.isRequired,
  user: PropTypes.object,
  route: PropTypes.object,
};

export default compose(
  withUser,
  withRoutes,
)(SaveModal);
